import { APIRequest } from '../../helpers/index.helper';
import { APP_TEXT_ENDPOINT } from '../../apiEndpoints/index.endpoint';
import { logger } from '../../utils';
export const quoteInformationService = async (body) => {
  try {
    const payload = {
      ...APP_TEXT_ENDPOINT.quoteInformation,
      bodyData: body,
    };
    const res = await APIRequest(payload);
    return res;
  } catch (err) {
    logger(err);
  }
};
export const getQuoteInformationService = async ({ queryParams }) => {
  try {
    const payload = {
      ...APP_TEXT_ENDPOINT.getQuoteInformation,
      queryParams,
    };
    const res = await APIRequest(payload);
    return res;
  } catch (err) {
    logger(err);
  }
};
